import { UserSelect } from "@/containers/Project/components";
import { GUTTER_SIZE } from "@/enums";
import { getLimitedListFromTemplateRoles } from "@/helpers";
import { IProjectMilestoneRole, ITemplateRolesMapping } from "@/interfaces";
import { Checkbox, Col, Form, Row } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { useIntl } from "react-intl";

interface IProps {
  role: IProjectMilestoneRole;
  editMode: boolean;
  disabledRoles: { [key: string]: boolean };
  handleToggle(event: CheckboxChangeEvent, key: string): void;
  templateRolesMap: { [key: string]: ITemplateRolesMapping };
}

export const MilestoneRoleField = ({
  role,
  editMode,
  disabledRoles,
  handleToggle,
  templateRolesMap,
}: IProps) => {
  const intl = useIntl();

  return (
    <Row
      key={`project-milestone-role-${role.id}`}
      gutter={GUTTER_SIZE.small}
      wrap={false}
      align="middle"
    >
      <Col flex="auto">
        <Form.Item
          label={role.name}
          initialValue={role.assignedUsers?.map((u) => u.userId)}
          name={[role.id, "assignedUsers"]}
        >
          <UserSelect
            multipleSelect
            showDeletedUsers={false}
            users={role.assignedUsers?.map((u) => u.userId)}
            limitedOptions={getLimitedListFromTemplateRoles(
              role,
              templateRolesMap
            )}
            disabled={disabledRoles[role.id]}
            readOnly={!editMode}
            dataTestId={`limited-list-role-${role.roleId}`}
          />
        </Form.Item>
      </Col>
      <Col style={{ minWidth: 65 }}>
        {role.canSetNotApplicable && (
          <Form.Item
            name={[role.id, "isNotApplicable"]}
            valuePropName="checked"
            initialValue={role.isNotApplicable}
            label={" "}
          >
            <Checkbox
              onChange={(e): void => handleToggle(e, role.id)}
              data-test-id={`milestone-set-na-toggle-${role.id}`}
              disabled={!editMode}
            >
              {intl.formatMessage({
                id: "project.notApplicable",
              })}
            </Checkbox>
          </Form.Item>
        )}
      </Col>
    </Row>
  );
};
